import { Statistic, Card, Typography } from 'antd';
import React, { useState, useEffect } from 'react';
import { backendURL } from "../Globals";

const { Title } = Typography;

const AvailablesComponent = () => {
  const [asignados, setAsignados] = useState([]);
  const [consumidos, setConsumidos] = useState([]);
  const [currentDate, setCurrentDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 🔹 Obtener los APCs asignados (ya no requiere API Key)
  const getAsignados = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${backendURL}/assigned`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      });

      if (response.ok) {
        const jsonData = await response.json();
        const maxYear = Math.max(...jsonData.map(item => item.year));
        const filteredData = jsonData.filter(item => item.year === maxYear);
        setAsignados(filteredData);
      } else {
        const jsonData = await response.json();
        setError(jsonData.error);
      }
    } catch (error) {
      setError('Error fetching data');
      console.error('Error fetching data:', error);
    }
  };

  // 🔹 Obtener los APCs consumidos (ya no requiere API Key)
  const getConsumidos = async () => {
    try {
      const response = await fetch(`${backendURL}/articles/consumed`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      });

      if (response.ok) {
        const jsonData = await response.json();
        setConsumidos(jsonData);
      } else {
        const jsonData = await response.json();
        setError(jsonData.error);
      }
    } catch (error) {
      setError('Error fetching data');
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAsignados();
    getConsumidos();

    const date = new Date();
    const formattedDate = date.toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
    setCurrentDate(formattedDate);
  }, []);

  if (error) {
    return <div>Error: {error}</div>;
  }

  const editorsData = asignados.map(asignado => {
    const consumido = consumidos.find(c => c.editor === asignado.editor)?.consumidos || 0;
    const assigned = asignado.apc_count || 0;
    const available = assigned - consumido;
    return {
      title: asignado.editor,
      assigned,
      consumidos: consumido,
      available: isNaN(available) ? assigned : Math.max(available, 0)
    };
  });

  const uniqueEditors = Array.from(new Map(editorsData.map(item => [item.title, item])).values());
  const sortedEditors = [...uniqueEditors].sort((a, b) => b.assigned - a.assigned);

  sortedEditors.push(
    { title: 'ACS', assigned: 0, consumidos: 0, available: 'Ilimitados' },
    { title: 'CUP', assigned: 0, consumidos: 0, available: 'Ilimitados' },
    { title: 'SCOAP', assigned: 0, consumidos: 0, available: 'Ilimitados' },
    { title: 'Elsevier', assigned: 0, consumidos: 0, available: 'Ilimitados' }
  );

  const titles = sortedEditors.map(editor => editor.title);
  const values = sortedEditors.map(editor => editor.available);

  const getGridColumn = (index) => {
    if (index < 3) return index + 1;
    if (index < 6) return index - 2;
    return index - 5;
  };

  const cardTitleStyle = {
    fontSize: '20px',
    fontWeight: '400',
    color: '#555',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    letterSpacing: '0.5px'
  };

  const statisticValueStyle = (value) => ({
    color: value === 'Agotados' ? '#ff4d4f' : '#1677ff',
    fontSize: '24px',
    fontWeight: '400',
  });

  return (
    <div className="availables-container">
      <h2 className="availables-title" style={{ marginBottom: '30px' }}>
        APCs disponibles - {currentDate}
      </h2>
      
      <div
        className="availables-cards-container"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, minmax(30px, 0.5fr))',
          gap: '32px 1px',
        }}
      >
        {titles.map((title, index) => (
  <Card
  className="availables-card"
  title={<span style={cardTitleStyle}>{title}</span>}
  bordered={false}
  key={index}
  style={{
    position: 'relative', // 👈 necesario para que el aviso se posicione dentro
    gridColumn: getGridColumn(index),
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.4)', 
    borderRadius: '8px', 
    padding: '8px',
    backgroundColor: '#ffffff',
    minHeight: '100px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '250px',
    margin: 'auto'
  }}
>
  {/* 🟨 Nota flotante solo para Wiley */}
  {title === 'Wiley' && (
  <div style={{
    position: 'absolute',
    top: '24px',              // Altura aproximada alineada con el título
    left: '-90px',           // Mueve la nube completamente a la izquierda de la card
    backgroundColor: '#fffbe6',
    color: '#cf1322',
    border: '1px solid #ffe58f',
    borderRadius: '8px',
    padding: '6px 10px',
    fontSize: '12px',
    fontWeight: 500,
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
    zIndex: 10,
    maxWidth: '150px',
    whiteSpace: 'normal'
  }}>
    {/* Rabito orientado hacia la derecha, pegado al borde izquierdo de la card */}
    <div style={{
      position: 'absolute',
      top: '10px',
      right: '-6px',
      width: 0,
      height: 0,
      borderTop: '6px solid transparent',
      borderBottom: '6px solid transparent',
      borderLeft: '6px solid #fffbe6'
    }} />
    Solo APCs híbridos. <br /> APCs Gold agotados.
  </div>
)}

  <Statistic
    className="availables-statistic"
    value={values[index] > 0 || values[index] === 'Ilimitados' ? values[index] : 'Agotados'}
    valueStyle={statisticValueStyle(values[index] > 0 || values[index] === 'Ilimitados' ? values[index] : 'Agotados')} 
  />
</Card>
))}
      </div>
    </div>
  );
};

export default AvailablesComponent;
